import { SET_PACIENTI } from './PacientiMutations'

import api from '@/api'

export default {
  loadPacienti ({ commit }, payload) {
    api
      .loadPacienti()
      .then(response => {
        commit(SET_PACIENTI, response)
      }
      )
      .catch(error => {
        console.log('Error: ', error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/pacienti/PacientiActions.js